import { FilterService } from "primereact/api";
import { DeveloperProfileConstants } from "sj-ui-toolkit/src/constants/developerProfile";

// Registered as a side-effect on import.
// Import this module once (e.g. in the Users page) to activate all custom filters.

// Known language option values for the "Other" catch-all in inCaseInsensitive.
const KNOWN_LANGUAGE_VALUES = new Set(
  DeveloperProfileConstants.OPTIONS.programmingLanguages.map(o => o.value)
);

// Case-insensitive IN filter with "other" catch-all for programming languages.
// Using a registered filter (not CUSTOM mode) ensures PrimeReact passes the full
// selection array as one argument, giving OR semantics across multiple selections.
FilterService.register("inCaseInsensitive", (value: unknown, filter: unknown) => {
  if (!filter || !Array.isArray(filter) || filter.length === 0) return true;
  if (typeof value !== "string") return false;
  const filterArr = filter as string[];
  const valueLower = value.toLowerCase();
  if (filterArr.includes(valueLower)) return true;
  // "other" is a catch-all: also matches values not in the known language list.
  if (filterArr.includes("other") && !KNOWN_LANGUAGE_VALUES.has(valueLower)) return true;
  return false;
});

// Returns true when the row value IS NOT in the predefined list ("other" values).
FilterService.register("custom_not_in", (value: unknown, filters: unknown[]) => {
  if (!filters || !Array.isArray(filters)) return true;
  if (value === null || value === "") return false;
  return !filters.includes(value);
});

// Returns true when ANY value in the row's array IS NOT in the predefined list.
FilterService.register("custom_array_not_in", (value: unknown, filters: unknown[]) => {
  if (!filters || !Array.isArray(filters) || !value || !Array.isArray(value)) return false;
  if ((value as unknown[]).length === 0) return false;
  return (value as unknown[]).some(item => !filters.includes(item));
});

// Returns true when the row's topics array contains the filter value.
FilterService.register("custom_array_contains", (rowTopics: unknown, filterValue: unknown) => {
  if (!Array.isArray(rowTopics) || filterValue == null) return false;
  const filters = Array.isArray(filterValue) ? filterValue : [filterValue];
  return (filters as unknown[]).some(f => (rowTopics as unknown[]).includes(f));
});
